module.exports = {
	"welcome": "Bienvenido <strong>%{name}</strong>",
	"actions": {
		"enter": "Entrar"
	},
	"models": {
		"user": {
			"username": "Nombre de usuário",
			"password": "Contraseña"
		}
	},
	"pages": {
		"login": {
			"title": "Conecte",
			"tip": "Punta <code>admin:123</code>"
		}
	},
	"modules": {
		"posts": {
			"new": "Nuovo post"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/es.json
// module id = 229
// module chunks = 2